// extracted by mini-css-extract-plugin
export var button = "_nd-2";
export var card = "_nd-0";
export var closeButtonContainer = "_nd-3";
export var iconContainer = "_nd-1";